import Vue from 'vue';
import VueRouter from 'vue-router';
import { refreshAccess, resetAccess, canVisit } from '@/services/posAccess';
import { TOKEN_KEY } from '../config';

Vue.use(VueRouter);

const routes = [
  { path: '/access-unavailable', name: 'AccessUnavailable', component: () => import('@/views/access/Unavailable.vue') },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/',
    component: () => import('@/components/Layout.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'pets', name: 'Pets', redirect: '/pets/care', meta: { headerOnly: true } },
      { path: 'pets/care', name: 'PetsCare', component: () => import('@/views/pets/Index.vue'), meta: { title: '今日照护', icon: 'el-icon-sunny', group: '萌宠管理', petSection: 'care' } },
      { path: 'pets/archive', name: 'PetsArchive', component: () => import('@/views/pets/Index.vue'), meta: { title: '萌宠档案', icon: 'el-icon-collection', group: '萌宠管理', petSection: 'archive' } },
      { path: 'pets/records', name: 'PetsRecords', component: () => import('@/views/pets/Index.vue'), meta: { title: '照护记录', icon: 'el-icon-notebook-2', group: '萌宠管理', petSection: 'records' } },
      { path: 'pets/loss', name: 'PetsLoss', component: () => import('@/views/pets/Index.vue'), meta: { title: '损耗记录', icon: 'el-icon-document-delete', group: '萌宠管理', petSection: 'loss' } },
      // ── 工作台 ──
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/Index.vue'),
        meta: { title: '首页概览', icon: 'el-icon-s-home', group: '工作台' },
      },

      // ── 收银交易 ──
      {
        path: 'shift',
        name: 'Shift',
        component: () => import('@/views/shift/Index.vue'),
        meta: {
          title: '交班结算',
          icon: 'el-icon-s-check',
          group: '收银交易',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
            'waiter',
          ],
        },
      },
      {
        path: 'desk',
        name: 'desk',
        component: () => import('@/views/desk/Index.vue'),
        meta: {
          title: '桌台管理',
          icon: 'el-icon-shopping-cart-full',
          group: '收银交易',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
            'waiter',
          ],
        },
      },
      {
        path: 'desk-area',
        name: 'DeskArea',
        component: () => import('@/views/deskarea/Index.vue'),
        meta: {
          title: '桌台区域',
          icon: 'el-icon-location-outline',
          group: '收银交易',
          roles: ['market_admin', 'shop_owner', 'financer', 'shop_manager'],
        },
      },
      {
        path: 'desk-manage',
        name: 'DeskManage',
        component: () => import('@/views/deskmanage/Index.vue'),
        meta: {
          title: '桌台基础',
          icon: 'el-icon-set-up',
          group: '收银交易',
          roles: ['market_admin', 'shop_owner', 'financer', 'shop_manager'],
        },
      },
      {
        path: 'cashier',
        name: 'Cashier',
        component: () => import('@/views/cashier/Index.vue'),
        meta: {
          title: '收银台',
          icon: 'el-icon-shopping-cart-full',
          group: '收银交易',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
            'waiter',
          ],
        },
      },
      {
        path: 'order',
        name: 'Order',
        component: () => import('@/views/order/Index.vue'),
        meta: {
          title: '订单管理',
          icon: 'el-icon-s-order',
          group: '收银交易',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
            'waiter',
          ],
        },
      },
      {
        path: 'refund',
        name: 'Refund',
        component: () => import('@/views/refund/Index.vue'),
        meta: {
          title: '退款管理',
          icon: 'el-icon-refresh-left',
          group: '收银交易',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
            'waiter',
          ],
        },
      },

      // ── 营销中心 ──
      {
        path: 'promotion',
        name: 'Promotion',
        component: () => import('@/views/promotion/Index.vue'),
        meta: {
          title: '促销活动',
          icon: 'el-icon-price-tag',
          group: '营销中心',
          roles: ['market_admin', 'shop_owner', 'financer', 'shop_manager'],
        },
      },
      {
        path: 'coupon',
        name: 'Coupon',
        component: () => import('@/views/coupon/Index.vue'),
        meta: {
          title: '优惠券管理',
          icon: 'el-icon-medal',
          group: '营销中心',
          roles: ['market_admin', 'shop_owner', 'financer', 'shop_manager'],
        },
      },
      {
        path: 'gift-card',
        name: 'GiftCard',
        component: () => import('@/views/giftcard/Index.vue'),
        meta: {
          title: '礼品卡',
          icon: 'el-icon-present',
          group: '营销中心',
          roles: ['market_admin', 'shop_owner', 'financer', 'shop_manager'],
        },
      },

      // ── 会员管理 ──
      {
        path: 'member',
        name: 'Member',
        component: () => import('@/views/member/Index.vue'),
        meta: {
          title: '会员档案',
          icon: 'el-icon-user',
          group: '会员管理',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
            'waiter',
          ],
        },
      },
      {
        path: 'points',
        name: 'Points',
        component: () => import('@/views/points/Index.vue'),
        meta: {
          title: '积分体系',
          icon: 'el-icon-star-on',
          group: '会员管理',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
            'waiter',
          ],
        },
      },
      {
        path: 'package',
        name: 'Package',
        component: () => import('@/views/package/Index.vue'),
        meta: {
          title: '季卡',
          icon: 'el-icon-postcard',
          group: '会员管理',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
            'waiter',
          ],
        },
      },
      {
        path: 'member-level',
        name: 'MemberLevel',
        component: () => import('@/views/memberlevel/Index.vue'),
        meta: {
          title: '等级权益',
          icon: 'el-icon-trophy',
          group: '会员管理',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
            'waiter',
          ],
        },
      },

      // ── 预约服务 ──
      {
        path: 'appointment',
        name: 'Appointment',
        component: () => import('@/views/appointment/Index.vue'),
        meta: {
          title: '预约管理',
          icon: 'el-icon-date',
          group: '预约服务',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
            'waiter',
          ],
        },
      },
      {
        path: 'service-item',
        name: 'ServiceItem',
        component: () => import('@/views/serviceitem/Index.vue'),
        meta: {
          title: '服务项目',
          icon: 'el-icon-scissors',
          group: '预约服务',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
            'waiter',
          ],
        },
      },

      // ── 商品管理 ──
      {
        path: 'product',
        name: 'Product',
        component: () => import('@/views/product/Index.vue'),
        meta: {
          title: '商品列表',
          icon: 'el-icon-goods',
          group: '商品管理',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
            'waiter',
          ],
        },
      },
      {
        path: 'category',
        name: 'Category',
        component: () => import('@/views/category/Index.vue'),
        meta: {
          title: '商品分类',
          icon: 'el-icon-menu',
          group: '商品管理',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
            'waiter',
          ],
        },
      },
      {
        path: 'barcode',
        name: 'Barcode',
        component: () => import('@/views/barcode/Index.vue'),
        meta: {
          title: '条码管理',
          icon: 'el-icon-coordinate',
          group: '商品管理',
          roles: [
            'market_admin',
            // 'shop_owner',
            // 'financer',
            // 'shop_manager',
            // 'cashier',
            // 'waiter',
          ],
        },
      },

      // ── 库存管理 ──
      {
        path: 'stock',
        name: 'Stock',
        component: () => import('@/views/stock/Index.vue'),
        meta: {
          title: '库存总览',
          icon: 'el-icon-box',
          group: '库存管理',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
          ],
        },
      },
      {
        path: 'stocktake',
        name: 'Stocktake',
        component: () => import('@/views/stocktake/Index.vue'),
        meta: {
          title: '库存盘点',
          icon: 'el-icon-document-checked',
          group: '库存管理',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
          ],
        },
      },
      {
        path: 'purchase',
        name: 'Purchase',
        component: () => import('@/views/purchase/Index.vue'),
        meta: {
          title: '采购入库',
          icon: 'el-icon-receiving',
          group: '库存管理',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
          ],
        },
      },
      {
        path: 'stock-alert',
        name: 'StockAlert',
        component: () => import('@/views/stockalert/Index.vue'),
        meta: {
          title: '库存预警',
          icon: 'el-icon-warning-outline',
          group: '库存管理',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
          ],
        },
      },

      // ── 员工中心 ──
      {
        path: 'employee',
        name: 'Employee',
        component: () => import('@/views/employee/Index.vue'),
        meta: {
          title: '员工档案',
          icon: 'el-icon-s-custom',
          group: '员工中心',
          roles: ['market_admin', 'shop_owner', 'financer', 'shop_manager'],
          shopLeader: true,
        },
      },
      {
        path: 'schedule',
        name: 'Schedule',
        component: () => import('@/views/schedule/Index.vue'),
        meta: {
          title: '排班管理',
          icon: 'el-icon-date',
          group: '员工中心',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
            'waiter',
          ],
          shopLeader: true,
        },
      },
      {
        path: 'commission',
        name: 'Commission',
        component: () => import('@/views/commission/Index.vue'),
        meta: {
          title: '提成规则',
          icon: 'el-icon-s-flag',
          group: '员工中心',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
            'waiter',
          ],
        },
      },
      {
        path: 'performance',
        name: 'Performance',
        component: () => import('@/views/performance/Index.vue'),
        meta: {
          title: '业绩看板',
          icon: 'el-icon-data-line',
          group: '员工中心',
          roles: ['market_admin', 'shop_owner', 'financer', 'shop_manager'],
        },
      },

      // ── 财务中心 ──
      {
        path: 'finance',
        name: 'Finance',
        component: () => import('@/views/finance/Index.vue'),
        meta: {
          title: '收支记录',
          icon: 'el-icon-money',
          group: '财务中心',
          roles: ['market_admin', 'shop_owner', 'financer', 'shop_manager'],
        },
      },
      {
        path: 'report',
        name: 'Report',
        component: () => import('@/views/report/Index.vue'),
        meta: {
          title: '经营报表',
          icon: 'el-icon-data-analysis',
          group: '财务中心',
          roles: ['market_admin', 'shop_owner', 'financer', 'shop_manager'],
        },
      },
      {
        path: 'cashflow',
        name: 'Cashflow',
        component: () => import('@/views/cashflow/Index.vue'),
        meta: {
          title: '资金流水',
          icon: 'el-icon-bank-card',
          group: '财务中心',
          roles: ['market_admin', 'shop_owner', 'financer', 'shop_manager'],
        },
      },
      {
        path: 'export',
        name: 'Export',
        component: () => import('@/views/export/Index.vue'),
        meta: {
          title: '数据导出',
          icon: 'el-icon-download',
          group: '财务中心',
          roles: ['market_admin', 'shop_owner', 'financer', 'shop_manager'],
        },
      },

      // ── 系统设置 ──
      {
        path: 'store-manage',
        name: 'StoreManage',
        component: () => import('@/views/store/Index.vue'),
        meta: {
          title: '门店信息',
          icon: 'el-icon-office-building',
          roles: ['market_admin', 'shop_owner', 'financer', 'shop_manager'],
          group: '系统设置',
        },
      },
      {
        path: 'gate',
        name: 'GateManage',
        component: () => import('@/views/gate/Index.vue'),
        meta: {
          title: '闸机管理',
          icon: 'el-icon-guide',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
          ],
          group: '系统设置',
        },
      },
      {
        path: 'user',
        name: 'UserManage',
        component: () => import('@/views/access/Index.vue'),
        meta: {
          title: '账号权限',
          icon: 'el-icon-lock',
          roles: ['market_admin'],
          group: '系统设置',
        },
      },
      {
        path: 'template',
        name: 'Template',
        component: () => import('@/views/template/Index.vue'),
        meta: {
          title: '打印模板设置',
          icon: 'el-icon-toilet-paper',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
          ],
          group: '系统设置',
        },
      },
      {
        path: 'printer',
        name: 'Printer',
        component: () => import('@/views/printer/Index.vue'),
        meta: {
          title: '打印与扫码',
          icon: 'el-icon-printer',
          roles: [
            'market_admin',
            'shop_owner',
            'financer',
            'shop_manager',
            'cashier',
          ],
          group: '系统设置',
        },
      },
      {
        path: 'payment-config',
        name: 'MerchantPayment',
        component: () => import('@/views/paymentconfig/Index.vue'),
        meta: { title: '商家支付', icon: 'el-icon-bank-card', roles: ['market_admin', 'shop_owner'], group: '系统设置' },
      },
      {
        path: 'notification',
        name: 'Notification',
        component: () => import('@/views/notification/Index.vue'),
        meta: {
          title: '通知设置',
          icon: 'el-icon-bell',
          roles: ['market_admin'],
          group: '系统设置',
        },
      },
      {
        path: 'operation-log',
        name: 'OperationLog',
        component: () => import('@/views/operationlog/Index.vue'),
        meta: {
          title: '操作日志',
          icon: 'el-icon-tickets',
          roles: ['market_admin'],
          group: '系统设置',
        },
      },

      // headerOnly（不显示在菜单）
    ],
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.path === '/login') {
    resetAccess();
    localStorage.clear();
    next();
    return;
  }
  if (!localStorage.getItem(TOKEN_KEY)) { next('/login'); return; }
  if (to.path === '/access-unavailable') { next(); return; }
  try {
    await refreshAccess(true);
    if (canVisit(to.path)) { next(); return; }
    const state = await refreshAccess();
    if (to.path === '/dashboard' && state.menuPaths.length) { next(state.menuPaths[0]); return; }
    next({ path: '/access-unavailable', query: { from: to.path } });
  } catch (error) {
    if (error.code === 'ACCESS_SUPERSEDED') {
      try { await refreshAccess(); if (canVisit(to.path)) { next(); return; } } catch (_) { /* Fall through to recovery. */ }
    }
    if (!localStorage.getItem(TOKEN_KEY)) { next('/login'); return; }
    next({ path: '/access-unavailable', query: { from: to.path } });
  }
});

export default router;
